<template>
  <thead
    class="text-xs text-secondary-700 uppercase bg-secondary-50 dark:bg-secondary-700 dark:text-secondary-400">
    <tr>
      <slot></slot>
    </tr>
  </thead>
</template>
<script lang="ts" setup></script>
